import { Omit } from '../../../../types/index';
import { ActionDescriptor } from '../../common';
import { DraperyOrderHeadrail, ChangeableDraperyOrderHeadrail } from './interfaces';

export const ADD_DRAPERY_ORDER_HEADRAIL = 'draperyOrderHeadrail/ADD';
export type AddDraperyOrderHeadrailAction = ActionDescriptor<
  typeof ADD_DRAPERY_ORDER_HEADRAIL,
  Omit<DraperyOrderHeadrail, 'id'> & { accountId: number },
  DraperyOrderHeadrail
>;

export const EDIT_DRAPERY_ORDER_HEADRAIL = 'draperyOrderHeadrail/EDIT';
export type EditDraperyOrderHeadrailAction = ActionDescriptor<
  typeof EDIT_DRAPERY_ORDER_HEADRAIL,
  ChangeableDraperyOrderHeadrail & { id: number },
  {}
>;

export interface DraperyOrderHeadrailActionsMap {
  [ADD_DRAPERY_ORDER_HEADRAIL]: AddDraperyOrderHeadrailAction;
  [EDIT_DRAPERY_ORDER_HEADRAIL]: EditDraperyOrderHeadrailAction;
}
